import {CommandBase} from "./commandBase";
import {RemoteConstantsModel} from "../models/remoteConstants.model";

export class RemoveUnitAttributeCommand extends CommandBase {
    unitId: string;
    attribute: string;

    constructor(unitId: string, attribute: string) {
        super();
        this.unitId = unitId;
        this.attribute = attribute;
    }

    execute(state: RemoteConstantsModel): boolean {
        const unitIndex = state.units.findIndex(u => u.id === this.unitId);
        if (unitIndex < 0) {
            return false;
        }

        const attributeIndex =  state.units[unitIndex].attributes.findIndex(a => a === this.attribute);
        if (attributeIndex < 0) {
            return false;
        }

        state.units[unitIndex].attributes.splice(attributeIndex, 1);
        return true;
    }
}